import AppStore from '@v4/store/appStore'
import QuizQuestionsSelector from '@v4/utils/selectors/QuizQuestionsSelector'

const useQuestionField = (questionId, name) => {
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)

	const appValue = AppStore.useStoreState(
		state => state.question.data?.[name === 'options' ? 'questionOptions' : name],
	)
	const builderValue = QuizQuestionsSelector.useQuestionField({ id: questionId, name })

	return isBuilderMode ? builderValue : appValue
}

export default useQuestionField
